import React, { Component } from 'react';
import { message, Icon, Spin, Alert } from 'antd';
import axios from 'axios';
import { devApiUrl, proApiUrl } from '../../utils/index'
// 样式引入
import './index.css';

//姓名引入
// import {dataList} from './assets/nameList';

//img
import background from './assets/images/background.jpg';
import carBackground from './assets/images/car.jpg';

// import {request} from '../../assets/config.js';
// import {defaultPath} from '../../assets/pageConfig.js';

//登录背景55
const loginBackgroundStyle = {
  position: 'absolute',
  width: '100%',
  minWidth: '1280px',
  height: '100%',
  left: '0px',
  top: '0px',
  index: '9999',
  background: 'url(' + background + ') no-repeat',
  backgroundSize: '100% 100%',
  minHeight: '600px',
  zIndex: 999
};

//登录框
const loginBoxStyle = {
  position: 'relative',
  top: '40%',
  left: '50%',
  width: '700px',
  height: '400px',
  margin: '-200px 0 0 -350px',
  background: 'url(' + carBackground + ') no-repeat',
  backgroundSize: '100% 100%',
  boxShadow: '30px 30px 100px 0px #000',
  borderRadius: '8px'
};

//域名解析
function urlParse(url) {
  let obj = {}
  /*
  * 正则匹配
  * [?&]:匹配?或&其一
  * [^?&]:非?或非&
  * */
  let reg = /[?&][^?&]+=[^?&]+/g
  let arr = url.match(reg)
  if (arr) {
    arr.forEach((item) => {
      let tempArr = item.substring(1).split('=')
      let key = tempArr[0]
      let val = tempArr[1]
      obj[key] = val
    })
  }
  return obj
}

//加密
function compileStr(code) {
  var c = String.fromCharCode(code.charCodeAt(0) + code.length);
  for (var i = 1; i < code.length; i++) {
    c += String.fromCharCode(code.charCodeAt(i) + code.charCodeAt(i - 1));
  }
  return escape(c);
}

//解密
function uncompileStr(code) {
  code = unescape(code);
  var c = String.fromCharCode(code.charCodeAt(0) - code.length);
  for (var i = 1; i < code.length; i++) {
    c += String.fromCharCode(code.charCodeAt(i) - c.charCodeAt(i - 1));
  }
  return c;
}


class Index extends Component {

  state = {
    //默认账号为空
    defaultUser: '',
    //默认密码为空
    defaultPassword: '',
    //账号
    user: '',
    //密码
    password: '',
    loading: false,
    //判断token,login页面是否显示
    loginLoading: false,
  }

  componentWillUnmount() {
    clearTimeout(this.pwdErrorTimer);
  }

  componentWillMount() {

    var url = urlParse(window.location.href);

    // var urls = 'http://ygsc.yunhaogroup.com/#/?appId=0b6297a9ea474192ad117328c56c1d98&token=eyJhbGciOiJIUzI1NiJ9.eyJqdGkiOiJmMjdkOTgyMjgxODQ0OTBmYjI0ZjEyYjNlMmU0ZjUxMiIsInN1YiI6IuaIkeaYr-S6keixquWRmOW3pSIsImlhdCI6MTU5MDA0MjEyMCwidXNlckFjY291bnQiOiJhZG1pbiIsInR5cGUiOiJwbGF0Zm9ybSIsInN0YWZmSWQiOiI1IiwiZXhwIjoxNTkwMDc4MTIwfQ.LmQEu0JCABjiOzfmig6esvAlwk55eN9vpTzUCcDQ7BI&appCode=567&r=0.2702474210166903';
    // var urls1 = 'http://localhost:3000/#/';
    // let url = urlParse(urls)

    if (url.token) {
      this.userLogin(url.token)
    }
  }

  componentDidMount() {
    const submitPassWord = JSON.parse(window.sessionStorage.getItem('submitPassWord'));

    if (submitPassWord) {
      this.setState({
        defaultUser: submitPassWord.defaultUser,
        defaultPassword: uncompileStr(submitPassWord.defaultPassword),
        user: submitPassWord.defaultUser,
        password: uncompileStr(submitPassWord.defaultPassword)
      }, () => {
        this.refs.submitPassWord.checked = true;
      })
    }
  }

  //账号
  setUser(event) {
    this.setState({ user: event.target.value });
  }
  //密码
  setPassword(event) {
    this.setState({ password: event.target.value });
  }

  // 记录应用登录日志
  addLoginLog(token, userCode) {
    axios({
      url: `${process.env.REACT_APP_ENV === "dev" ? devApiUrl : proApiUrl}/portal/log/appAccess/recordAppLoginInfo/handbook/${userCode}`,
      headers: { "Content-Type": "application/json", "Authorization": token },
      method: "post",
    }).then(function (response) {
      console.log('日志记录成功', response)
    })
  }

  userLogin(token) {
    var _this = this;
    this.setState({ loginLoading: true })
    //从门户系统过来
    axios({
      url: `${process.env.REACT_APP_ENV === "dev" ? devApiUrl : proApiUrl}/portal/auth/login/verify`,
      headers: { "Authorization": token },
      method: "post",
      data: {
        sourceApp: "handbook",
        token: token,
      }
    })
      .then(function (response) {
        if (response.data.retCode - '' === 200) {
          this.setState({ loginLoading: false })
          const { userCode, userName } = response.data.retData
          window.sessionStorage.setItem('userName', JSON.stringify(userName));
          window.sessionStorage.setItem('userCode', JSON.stringify(userCode));
          window.sessionStorage.setItem('token', token);
          _this.addLoginLog(token, userCode)
          // window.sessionStorage.setItem('userInfo', JSON.stringify(response.data.retData));
          // window.sessionStorage.setItem('token', url.token);
          // window.sessionStorage.setItem('appCode', url.appCode);
          _this.props.history.push("data")
          //  window.location.href = window.location.origin + window.location.pathname + '#/data';
        } else {
          message.warning(response.data)
          this.setState({ loginLoading: false })
        }
      }.bind(this))
  }
  //登陆
  login = () => {
    // console.log(this.props.history)
    const { user, password } = this.state;
    var _this = this;
    this.setState({ loading: true });
    if (this.refs.submitPassWord.checked) {
      window.sessionStorage.setItem('submitPassWord', JSON.stringify({
        defaultUser: user,
        defaultPassword: compileStr(password)
      }));
    }

    if (user && password) {

      let data = {};
      data['userCode'] = user;
      data['userPassword'] = password;

      axios({
        url: `${process.env.REACT_APP_ENV === "dev" ? devApiUrl : proApiUrl}/portal/auth/login/login`,
        headers: { "Content-Type": "application/json" },
        method: "post",
        data,
      })
        .then(function (response) {
          if (response.data.retCode - '' === 200) {
            const token = response.data.retData
            // _this.addLoginLog(token, user)
            _this.setState({ loading: false })
            // window.sessionStorage.setItem('userCode', JSON.stringify(user));
            // window.sessionStorage.setItem('token', token);
            _this.userLogin(token)
            // window.location.href = window.location.origin + window.location.pathname +'#/data';
            // _this.props.history.push("data")
            // console.log(window.location.href)
          } else {
            _this.setState({ loading: false })
            message.error(response.data.retMsg)
          }
        })
    } else {
      _this.setState({ loading: false })
      message.warning('账号或者密码不能为空！');
    }
  }

  render() {

    const { loading, loginLoading, defaultUser, defaultPassword } = this.state;
    const antIcon = <Icon type="loading" style={{ fontSize: 24, color: '#fff', position: 'absolute', left: '50%', top: '15px', marginLeft: '-12px' }} />;

    return (
      loginLoading ?
        <Spin tip='页面加载中，请稍等...' size="large" >
          <Alert
            message=""
            description=""
            type="info"
            style={{ padding: '100px 0', textLeft: '20px', marginTop: '50px', overflow: 'hidden', border: 'none', background: 'none' }}
          />
        </Spin>
        :
        <div style={loginBackgroundStyle}>
          {loading ? antIcon : null}
          <div style={loginBoxStyle}>
            &nbsp;版本：v 1.0.0
            {/*登录logo*/}
            <div className="login-logo"></div>
            {/*登录logo end*/}

            <div className="login-box">
              {/*登录title*/}
              <div className="login-title">
                <p>云豪集团内部文档管理平台</p>
                <span>-笃实·诚信·创新·共赢-</span>
              </div>
              {/*登录title end*/}

              {/*账号密码录入*/}
              <div className="login-login">
                <p><input type="text" placeholder='账号' defaultValue={defaultUser} onChange={this.setUser.bind(this)} /><span></span></p>
                <p><input type="password" placeholder='密码' defaultValue={defaultPassword} onChange={this.setPassword.bind(this)} /><span></span></p>
                <div>
                  <span><input type="checkbox" ref="submitPassWord" /> 记住密码</span>
                </div>
                <button onClick={this.login}>登陆</button>
              </div>
              {/*账号密码录入 end*/}
            </div>
          </div>
        </div>

    )
  }

}

export default Index;